import { Grid, useMediaQuery, useTheme } from "@mui/material";
import type { FC } from "react";

type TeachImgProps = {
  url: string;
};

export const TeachImg: FC<TeachImgProps> = ({ url }) => {
  // responsive UI
  const theme = useTheme();
  const notPhone = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <Grid
      size={{ xs: 12 }}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: notPhone ? "calc(100vh - 360px)" : "auto",
        zIndex: 1,
      }}
    >
      <img
        src={url}
        alt="快捷功能教学图"
        style={{
          maxWidth: "100%",
          maxHeight: "100%",
          border: `1px solid ${theme.palette.secondary.dark}`,
          boxShadow: `0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)`,
          borderRadius: "5px",
        }}
      />
    </Grid>
  );
};
